'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _fitnessTotals = require('../../api/fitness-totals');

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _heading = require('constructicon/heading');

var _heading2 = _interopRequireDefault(_heading);

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

var _metric = require('constructicon/metric');

var _metric2 = _interopRequireDefault(_metric);

var _progressBar = require('constructicon/progress-bar');

var _progressBar2 = _interopRequireDefault(_progressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FitnessProgressBar = function (_Component) {
  _inherits(FitnessProgressBar, _Component);

  function FitnessProgressBar() {
    _classCallCheck(this, FitnessProgressBar);

    var _this = _possibleConstructorReturn(this, (FitnessProgressBar.__proto__ || Object.getPrototypeOf(FitnessProgressBar)).call(this));

    _this.calculatePercentage = _this.calculatePercentage.bind(_this);
    _this.fetchData = _this.fetchData.bind(_this);
    _this.state = { status: 'fetching' };
    return _this;
  }

  _createClass(FitnessProgressBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var refreshInterval = this.props.refreshInterval;

      this.fetchData();
      this.interval = refreshInterval && setInterval(this.fetchData, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      var _props = this.props,
          campaign = _props.campaign,
          fitnessTypes = _props.fitnessTypes;

      (0, _fitnessTotals.fetchFitnessTotals)(campaign, fitnessTypes).then(function (_ref) {
        var distance = _ref.distance;
        return _this2.setState({ status: 'fetched', distance: distance });
      }).catch(function () {
        return _this2.setState({ status: 'failed' });
      });
    }
  }, {
    key: 'calculateDaysRemaining',
    value: function calculateDaysRemaining(eventDate) {
      var today = (0, _moment2.default)();
      var eventMoment = (0, _moment2.default)(eventDate);
      var daysDiff = Math.ceil(eventMoment.diff(today, 'days', true)); // we want to round up
      return Math.max(0, daysDiff);
    }
  }, {
    key: 'calculatePercentage',
    value: function calculatePercentage() {
      var _props2 = this.props,
          offset = _props2.offset,
          target = _props2.target;
      var _state$distance = this.state.distance,
          distance = _state$distance === undefined ? 0 : _state$distance;

      return Math.min(100, Math.floor((distance / 1000 + offset) / target * 100));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          distanceLabel = _props3.distanceLabel,
          eventDate = _props3.eventDate,
          grid = _props3.grid,
          format = _props3.format,
          heading = _props3.heading,
          metric = _props3.metric,
          offset = _props3.offset,
          progressBar = _props3.progressBar,
          remainingLabel = _props3.remainingLabel,
          target = _props3.target,
          targetLabel = _props3.targetLabel,
          travelledLabel = _props3.travelledLabel,
          unit = _props3.unit;
      var _state = this.state,
          status = _state.status,
          _state$distance2 = _state.distance,
          distanceInMeters = _state$distance2 === undefined ? 0 : _state$distance2;

      var distanceInKm = distanceInMeters / 1000;
      var distance = unit === 'km' ? distanceInKm : distanceInKm * 0.621371;

      return status === 'fetched' ? _react2.default.createElement(
        _grid2.default,
        _extends({ spacing: 0.25 }, grid),
        _react2.default.createElement(
          _gridColumn2.default,
          { xs: 6 },
          _react2.default.createElement(_metric2.default, _extends({
            align: 'left',
            label: distanceLabel,
            amount: '' + (0, _numbro2.default)(distance + offset).format(format) + unit
          }, metric))
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          { xs: 6, xsAlign: 'right' },
          _react2.default.createElement(_metric2.default, _extends({
            align: 'right',
            label: targetLabel,
            amount: '' + (0, _numbro2.default)(target).format(format) + unit
          }, metric))
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          null,
          _react2.default.createElement(_progressBar2.default, _extends({
            alt: '<%= progress %>% there',
            progress: this.calculatePercentage()
          }, progressBar))
        ),
        travelledLabel ? _react2.default.createElement(
          _gridColumn2.default,
          { xs: 6 },
          _react2.default.createElement(
            _heading2.default,
            _extends({ size: 0, tag: 'strong' }, heading),
            this.calculatePercentage(),
            '%'
          ),
          ' ',
          travelledLabel
        ) : _react2.default.createElement(_gridColumn2.default, { xs: 6 }),
        remainingLabel && eventDate && _react2.default.createElement(
          _gridColumn2.default,
          { xs: 6, xsAlign: 'right' },
          _react2.default.createElement(
            _heading2.default,
            _extends({ size: 0, tag: 'strong' }, heading),
            this.calculateDaysRemaining(eventDate)
          ),
          ' ',
          remainingLabel
        )
      ) : _react2.default.createElement(_loading2.default, null);
    }
  }]);

  return FitnessProgressBar;
}(_react.Component);

FitnessProgressBar.propTypes = {
  /**
   * The campaign uid to fetch totals for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Unit
   */
  unit: _propTypes2.default.oneOf(['mi', 'km']),

  /**
   * Offset
   */
  offset: _propTypes2.default.number,

  /**
   * Target
   */
  target: _propTypes2.default.number.isRequired,

  /**
   * Raised label
   */
  distanceLabel: _propTypes2.default.string,

  /**
   * Target label
   */
  targetLabel: _propTypes2.default.string,

  /**
   * Show funded label
   */
  travelledLabel: _propTypes2.default.string,

  /**
   * Show time remaining label
   */
  remainingLabel: _propTypes2.default.string,

  /**
   * Props to be passed to the Constructicon Grid component
   */
  grid: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon Heading components
   */
  heading: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon Metric components
   */
  metric: _propTypes2.default.object,

  /**
   * Props to be passed to the Constructicon ProgressBar component
   */
  progressBar: _propTypes2.default.object,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

FitnessProgressBar.defaultProps = {
  format: '0,0',
  unit: 'km',
  offset: 0
};

exports.default = FitnessProgressBar;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/fitness-progress-bar/index.js
// module id = 1434
// module chunks = 0